export { ServiceIcon } from './ServiceIcon';
export type { ServiceIconSize } from './ServiceIcon';
